var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialImpact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "329.013 214.03 19.751 23.792",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 326.888672, 213.924942)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 13.5763,
    cy: 16.2713,
    r: 13.1642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#62CBF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    style: {
      stopColor: "#3FC0F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5707,
    style: {
      stopColor: "#21B7F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8233,
    style: {
      stopColor: "#0EB1EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#07AFEF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.23,6.37c-1.11-0.11-1.87,2.03-1.87,2.03c-0.78,2.7-1.73,3.57-1.73,3.57c-0.47-0.25,0.18-2.93,0.18-2.93 c0.51-2.33,0.98-5.81,0.98-5.81c0.16-2.05-1.06-1.67-1.06-1.67c-1.66,0.39-2.04,5.96-2.04,5.96c-0.37,2.81-1.16,2.93-1.16,2.93 C14.3,10.4,14.3,9.89,14.3,9.89c0.2-2.23,0.41-7.76,0.41-7.76c0.05-1.25-0.31-1.59-0.31-1.59c-0.52-0.63-1.15-0.39-1.15-0.39 c-0.89,0.16-1.03,1.95-1.03,1.95c0.01,1.53-0.43,7-0.43,7c-0.1,1.37-0.42,1.13-0.42,1.13c-0.56-0.25-0.53-1.28-0.53-1.28 c0.12-3.26-0.38-6.64-0.38-6.64C9.94,0.56,8.48,1.65,8.48,1.65c-0.8,1.26-0.41,4.06-0.41,4.06c0.29,2.87,0.05,5.58,0.05,5.58 c-0.18,2.59-1.07,1.56-1.07,1.56C5.29,10.1,3.34,9.73,3.34,9.73c-1.7-0.04-1.12,1.46-1.12,1.46c1.31,1.49,3.35,5.58,3.35,5.58 c2.03,5.25,3.44,5.87,3.44,5.87s0,0,0.01,0.01c0.24,0.21,3.12,2.56,7.02,0.21c0.01-0.01,0.02-0.01,0.03-0.02 c0.03-0.01,0.05-0.02,0.08-0.03c0.91-0.45,1.63-1.9,2.12-3.19c0.06-0.17,0.12-0.32,0.17-0.47c0.03-0.08,0.06-0.15,0.08-0.22 c0.01-0.02,0.01-0.03,0.02-0.05c0.02-0.09,0.05-0.16,0.07-0.25c0.01-0.02,0.02-0.04,0.03-0.06c0.01-0.06,0.03-0.11,0.05-0.17 C18.9,17.73,19,17.26,19,17.26c0.43-2.37,2.58-8.24,2.58-8.24C22.41,6.56,21.23,6.37,21.23,6.37z M17.03,16.94 c-0.5,0.74-1.24,1.29-2,1.75c-0.58,0.36-1.18,0.67-1.8,0.94c-0.06,0.02-0.12,0.05-0.19,0.04c-0.06-0.01-0.12-0.05-0.16-0.1 c-0.21-0.17-0.42-0.35-0.63-0.53c-0.61-0.52-1.23-1.05-1.73-1.68c-0.49-0.64-0.87-1.39-0.91-2.2C9.6,15,9.6,14.83,9.62,14.67 c0.15-1.14,1.24-2.39,2.49-2.12c0.71,0.16,1.18,0.8,1.59,1.4c0.3-0.26,0.6-0.52,0.94-0.71c0.35-0.19,0.74-0.31,1.14-0.27 c0.3,0.04,0.59,0.18,0.84,0.36c0.36,0.27,0.66,0.64,0.82,1.07C17.75,15.23,17.52,16.2,17.03,16.94z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialImpact);
export default __webpack_public_path__ + "static/media/SocialImpact.01943b37a314dcbb65db8d05a7cd69d3.svg";
export { ForwardRef as ReactComponent };